import { faCommentAltLines } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  Container,
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    padding: var(--spacing-08) var(--spacing-06) var(--spacing-05);
  }
  ${Container} {
    width: auto;
    max-width: max-content;
  }
`;

export const CommentsEmptyState = () => (
  <EmptyStateContainer $transparent>
    <EmptyState
      image={<EmptyStateIcon icon={faCommentAltLines} />}
      title={<FormattedMessage id="document.comments.empty.title" />}
      message={<FormattedMessage id="document.comments.empty.message" />}
    />
  </EmptyStateContainer>
);
